let host = 'https://fidelity-herbolariosaludnatural.lineagrafica.es';
let fidelityDiv = document.querySelector('.product-info__fidelity');

const getFidelitySettings = async() =>{
    let response = await fetch(`${host}/public/api/settings?shop=herbolario-salud-natural.myshopify.com`,{
        method: 'GET',
    })
    let responseJson = await response.json();
    console.log(responseJson);

    drawLabelFidelity(responseJson.data);
}

const drawLabelFidelity = async(data) =>{
    let cart = await fetch('/cart.js');
    let cartJson = await cart.json();
    
    let priceDiv = document.querySelector('.price__current');
    let price = priceDiv.textContent.replace(/<[^>]*>/g, '');
    price = price.replace('€', '')/100;
    console.log(cartJson)


    let productAward = Math.floor((price * data.cashbackPercent/100 + Number.EPSILON) * 100) / 100;
    let cartAward = Math.floor((cartJson.total_price/100 * data.cashbackPercent/100 + Number.EPSILON) * 100) / 100;
    
    fidelityDiv.innerHTML = `
        <p>Comprando este producto conseguirás <b>${productAward}€</b> con nuestro programa de fidelización. <br/>Con tu pedido sumarás <b>${cartAward}€</b> al saldo de tu cuenta.</p>
    `;
    fidelityDiv.style.display = 'block';
}

if(fidelityDiv){
    getFidelitySettings();
}

// setTimeout(() => {    
//     let labelOffer = document.querySelector('.deco-product-below-title');
//     let productPrice = document.querySelector('.product-label-wrapper');
//     if(labelOffer){
//       productPrice.appendChild(labelOffer);
//       labelOffer.style.opacity = "1";
//       labelOffer.style.display = "flex";
//     }

// },1500)